import { AppResource } from "../../types/resource.types";
import adsResource from "./ads";
import brandsResource from "./brands";
import brandsCategoriesResource from "./brandsCategories";
import categoriesResource from "./categories";
import clientsResource from "./clients";
import courtsResource from "./courts";
import courtsReservationsResource from "./courtsReservations";
import faqsResource from "./faqs";
import productsResource from "./products";
import sportsClubsResource from "./sportsClubs";
import sportsClubsReviewsResource from "./sportsClubsReviews";
import userGuideResource from "./userGuide";
import ordersResource from "./orders";
import requestsResource from "./requests";
import placesResource from "./places";
import agentsResource from "./agents";
import challengesResource from "./challenges";
import gymsResource from "./gyms";
import gymReviewsResource from "./gymReviews";
import adminGymReviewsResource from "./gymReviews/adminReviews";
import gymMembersResource from "./gymMembers";
import academiesResource from "./academies";
import sportTypesResource from "./sportTypes";
import coachesResource from "./coaches";
import academyTrainersResource from "./academyTrainer";
import academyMembersResource from "./academyMembers";
import coachsReservationsResource from "./coachsReservations";
import academyReviewsResource from "./academyReviews";
import adminAcademyReviewsResource from "./academyReviews/adminReviews";
import coachReviewsResource from "./coachReviews";
import adminCoachReviewsResource from "./coachReviews/adminReviews";
import vendorPackagesResource from "./vendorPackages";
import entertainmentsResource from "./entertainments";
import adventureRequestsResource from "./entertainmentRequests/adventureRequests";
import entertainmentReviewsResource from "./entertainmentReviews";
import entertainmentServicesResource from "./entertainmentsServices/entertainmentServices";
import adventureServicesResource from "./entertainmentsServices/adventureServices";
import entertainmentRequestsResource from "./entertainmentRequests/entertainmentRequests";
import sportMateEventsResource from "./sportMateEvents";
import announcementsResource from "./announcements";

export const requestOverrides: any = {
  ...userGuideResource,
  ...categoriesResource,
  ...sportsClubsResource,
  ...clientsResource,
  ...courtsResource,
  ...faqsResource,
  ...courtsReservationsResource,
  ...sportsClubsReviewsResource,
  ...adsResource,
  ...brandsCategoriesResource,
  ...brandsResource,
  ...productsResource,
  ...ordersResource,
  ...requestsResource,
  ...placesResource,
  ...agentsResource,
  ...challengesResource,
  ...gymsResource,
  ...gymReviewsResource,
  ...adminGymReviewsResource,
  ...gymMembersResource,
  ...sportTypesResource,
  ...academiesResource,
  ...academyTrainersResource,
  ...academyMembersResource,
  ...academyReviewsResource,
  ...adminAcademyReviewsResource,
  ...vendorPackagesResource,
  ...sportMateEventsResource,

  ...coachesResource,
  ...coachsReservationsResource,
  ...coachReviewsResource,
  ...adminCoachReviewsResource,

  ...entertainmentsResource,
  ...adventureRequestsResource,
  ...entertainmentRequestsResource,
  ...entertainmentReviewsResource,

  ...adventureServicesResource,
  ...entertainmentServicesResource,
  ...announcementsResource,
};

export const resourceNameOverrides: any = {
  [AppResource.adminGymReviews]: AppResource.gymReviews,
  [AppResource.adminAcademyReviews]: AppResource.academyReviews,
  [AppResource.adminCoachReviews]: AppResource.coachReviews,
  [AppResource.adventureRequests]: AppResource.entertainmentRequests,
};
